import React from 'react'
import T from 'prop-types'
import Image from 'next/image'

import BEMHelper from '../../helpers/bem'
import styles from './Styles.module.scss'
import Link from '../Link'
import { getImageUrl } from '../../api/sanity'
import { nanoid } from 'nanoid'

const bem = new BEMHelper(styles)

export default function FileEntry({ title, preamble, items = [], ...props }) {
  if (!items?.length) {
    return null
  }

  return (
    <section {...props} {...bem('')}>
      <header {...bem('header')}>
        <h2 {...bem('title')}>{title}</h2>
        {preamble && <p {...bem('preamble')}>{preamble}</p>}
      </header>

      <ul {...bem('list')}>
        {items.map(({ _id, title, preamble, image, file }) => {
          const href = file?.asset?.url || ''
          const src = image?.asset ? getImageUrl(image).height(300).format('jpg').url() : image

          return (
            <li {...bem('item')} key={_id}>
              <div key={nanoid()} {...bem('content')}>
                <h3 {...bem('sub-title')}>{title}</h3>
                {preamble && <p {...bem('description')}>{preamble}</p>}
                <Link href={href} {...bem('download')} download target="_blank">
                  Last ned ↓
                </Link>
              </div>
              {src && (
                <Image
                  key={nanoid()}
                  {...bem('image')}
                  src={src}
                  alt={image?.alt ?? ''}
                  height={image?.dimensions?.height ?? 300}
                  width={image?.dimensions?.width ?? 0}
                />
              )}
            </li>
          )
        })}
      </ul>
    </section>
  )
}

const entryPropTypes = {
  _id: T.string,
  preamble: T.string,
  title: T.string.isRequired,
  image: T.object,
  file: T.object,
}

FileEntry.propTypes = {
  preamble: T.string,
  title: T.string.isRequired,
  items: T.arrayOf(T.shape(entryPropTypes)),
}
